<div class="container-fluid full-width">

    <div class="ups-component hero has-breadcrumbs">
      <div class="ups-container">
        <div class="card ups-card">
          <div class="card-img fade-in-up-light"><img src="../../../assets/redesignImages/contact_us.png" alt="Woman packaging a box"
              title="Woman packaging a box" class="img-fluid" loading="lazy">
          </div>
          <div class="card-body fade-in-up-light">
            <div class="card-body-content">
              <h1 class="maj-head0">We Have Moved!</h1>
              <p class="maj-sub0">Don’t worry, we’re still here to answer your questions. Submit an inquiry
                below and someone from our team will be in touch.</p>
  
            </div>
          </div>
        </div>
      </div>
      <div class="arc-container">
        <svg xmlns="" width="1440" class="arc" height="72" viewBox="0 0 1440 72" fill="none" aria-hidden="true"
          focusable="false">
          <path d="M-400 176C139.222 -24.794 1028.42 -10.941 1440 13.8751V176L-400 176Z" fill="white"></path>
        </svg>
      </div>
    </div>
    <div class="arc-container">
      <img class="business-services-curved-image" alt="background-arc" src="../../../assets/redesignImages/Vector.png" width="1440" height="0">
    </div>
  
  
  
    <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
      <h2 class="comm-head comm-pay-head">
        Let’s Connect</h2>
      <p></p>
      <p></p>
  
    </div>
  
    <div class="container input-form">
  
  
      <form class="form-st" method="POST" id="lead-form" action="/submit/">
        <div id="errors-lead-form"></div>
        <div id="success-message-area">Submission Successful</div>
        <div class="sr-only">
          <input type="hidden" name="posted" value="True">
          <input type="checkbox" aria-label="BotTrap" name="BotTrap" id="BotTrap" value="1" tabindex="-1">
          <input type="hidden" name="CountryCode" id="CountryCode" value="US">
          <input type="hidden" name="LanguageCode" id="LanguageCode" value="EN">
          <input type="hidden" name="CampaignID" id="CampaignID" value="1">
          <input type="hidden" name="WebtrendsID" id="WebtrendsIDx" value="CAPITAL_US">
          <input type="hidden" name="RegionCode" id="RegionCode" value="US">
          <input type="hidden" name="SourceID" id="SourceID" value="1">
          <input type="hidden" name="posted" value="True">
          <input type="hidden" name="CaptchaVal" id="CaptchaVal" value="">
          <input type="hidden" name="Referrer" id="Referrer" value="https://upscapital.com/contact-ups-capital/">
          <input type="hidden" name="ExistingCustomer" id="ExistingCustomer" value="0">
          <input type="hidden" name="ChannelValue" id="ChannelValue" value="">
          <input type="hidden" name="cpi" id="cpi" value="1">
        </div>
  
        <div class="form-group col lab-0">
          <label for="inputEmail4" class="visible-label">Required Fields <em class="em-style">*</em></label>
        </div>
        <div class="row sp-fm0">
          <div class="col dis_1">
            <input type="text" class="form-control" placeholder="First Name *" aria-label="First Name *" name="FirstName"
              required>
            <span class="error errorFirstName">First name is required</span>
            <span class="error invalidFirstName">First name is invalid</span>
          </div>
          <div class="col dis_1">
            <input type="text" class="form-control" placeholder="Last Name *" aria-label="Last Name *" name="LastName"
              required>
            <span class="error errorLastName">Last name is required</span>
            <span class="error invalidLastName">Last name is invalid</span>
          </div>
        </div>
        <div class="row sp-fm0">
          <div class="col dis_1 ">
            <input type="text" class="form-control" aria-label="Company Name *" placeholder="Company Name *"
              name="CompanyName" required>
            <span class="error errorCompanyName">Company name is required</span>
            <span class="error invalidCompanyName">Company name is invalid</span>
          </div>
          <div class="col dis_1">
            <select id="inputState" aria-label="Country" class="form-select ds" name="Country" required>
              <option label="Country or Territory *" value="" disabled selected>Country or Territory *
              </option>
              <option label="Belgium" value="BE">Belgium</option>
              <option label="Canada" value="CA">Canada</option>
              <option label="China" value="CN">China</option>
              <option label="France" value="FR">France</option>
              <option label="Germany" value="DE">Germany</option>
              <option label="Hong Kong" value="HK">Hong Kong</option>
              <option label="Italy" value="IT">Italy</option>
              <option label="Mexico" value="MX">Mexico</option>
              <option label="Netherlands" value="NL">Netherlands</option>
              <option label="Poland" value="PL">Poland</option>
              <option label="Spain" value="ES">Spain</option>
              <option label="Thailand" value="TH">Thailand</option>
              <option label="United Kingdom" value="GB">United Kingdom</option>
              <option label="United States" value="US">United States</option>
            </select>
            <span class="error errorCountry">Country is required</span>
            <span class="error invalidCountry">Country is invalid</span>
          </div>
        </div>
        <div class="row sp-fm0">
          <div class="col dis_1">
            <select id="StateProvinceRegion" aria-label="State" class="form-select ds" name="StateProvinceRegion"
              disabled>
              <option value="" disabled="" selected="">State/Province</option>
              <option value="AK" class="US-State State-Options">Alaska</option>
              <option value="AZ" class="US-State State-Options">Arizona</option>
              <option value="AR" class="US-State State-Options">Arkansas</option>
              <option value="CA" class="US-State State-Options">California</option>
              <option value="CO" class="US-State State-Options">Colorado</option>
              <option value="CT" class="US-State State-Options">Connecticut</option>
              <option value="DE" class="US-State State-Options">Delaware</option>
              <option value="DC" class="US-State State-Options">District Of Columbia</option>
              <option value="FL" class="US-State State-Options">Florida</option>
              <option value="GA" class="US-State State-Options">Georgia</option>
              <option value="HI" class="US-State State-Options">Hawaii</option>
              <option value="ID" class="US-State State-Options">Idaho</option>
              <option value="IL" class="US-State State-Options">Illinois</option>
              <option value="IN" class="US-State State-Options">Indiana</option>
              <option value="IA" class="US-State State-Options">Iowa</option>
              <option value="KS" class="US-State State-Options">Kansas</option>
              <option value="KY" class="US-State State-Options">Kentucky</option>
              <option value="LA" class="US-State State-Options">Louisiana</option>
              <option value="ME" class="US-State State-Options">Maine</option>
              <option value="MD" class="US-State State-Options">Maryland</option>
              <option value="MA" class="US-State State-Options">Massachusetts</option>
              <option value="MI" class="US-State State-Options">Michigan</option>
              <option value="MN" class="US-State State-Options">Minnesota</option>
              <option value="MS" class="US-State State-Options">Mississippi</option>
              <option value="MO" class="US-State State-Options">Missouri</option>
              <option value="MT" class="US-State State-Options">Montana</option>
              <option value="NE" class="US-State State-Options">Nebraska</option>
              <option value="NV" class="US-State State-Options">Nevada</option>
              <option value="NH" class="US-State State-Options">New Hampshire</option>
              <option value="NJ" class="US-State State-Options">New Jersey</option>
              <option value="NM" class="US-State State-Options">New Mexico</option>
              <option value="NY" class="US-State State-Options">New York</option>
              <option value="NC" class="US-State State-Options">North Carolina</option>
              <option value="ND" class="US-State State-Options">North Dakota</option>
              <option value="OH" class="US-State State-Options">Ohio</option>
              <option value="OK" class="US-State State-Options">Oklahoma</option>
              <option value="OR" class="US-State State-Options">Oregon</option>
              <option value="PA" class="US-State State-Options">Pennsylvania</option>
              <option value="RI" class="US-State State-Options">Rhode Island</option>
              <option value="SC" class="US-State State-Options">South Carolina</option>
              <option value="SD" class="US-State State-Options">South Dakota</option>
              <option value="TN" class="US-State State-Options">Tennessee</option>
              <option value="TX" class="US-State State-Options">Texas</option>
              <option value="UT" class="US-State State-Options">Utah</option>
              <option value="VT" class="US-State State-Options">Vermont</option>
              <option value="VA" class="US-State State-Options">Virginia</option>
              <option value="WA" class="US-State State-Options">Washington</option>
              <option value="WV" class="US-State State-Options">West Virginia</option>
              <option value="WI" class="US-State State-Options">Wisconsin</option>
              <option value="WY" class="US-State State-Options">Wyoming</option>
  
              <option value="CH" class="State-Options MX-State">Chihuahua</option>
              <option value="SO" class="State-Options MX-State">Sonora</option>
              <option value="CO" class="State-Options MX-State">Coahuila</option>
              <option value="DU" class="State-Options MX-State">Durango</option>
              <option value="OA" class="State-Options MX-State">Oaxaca</option>
              <option value="TM" class="State-Options MX-State">Tamaulipas</option>
              <option value="JA" class="State-Options MX-State">Jalisco</option>
              <option value="ZA" class="State-Options MX-State">Zacatecas</option>
              <option value="BS" class="State-Options MX-State">Baja California Sur</option>
              <option value="CP" class="State-Options MX-State">Chiapas</option>
              <option value="VE" class="State-Options MX-State">Veracruz</option>
              <option value="BC" class="State-Options MX-State">Baja California</option>
              <option value="NL" class="State-Options MX-State">Nuevo León</option>
              <option value="GR" class="State-Options MX-State">Guerrero</option>
              <option value="SL" class="State-Options MX-State">San Luis Potosí</option>
              <option value="MI" class="State-Options MX-State">Michoacán</option>
              <option value="SI" class="State-Options MX-State">Sinaloa</option>
              <option value="CM" class="State-Options MX-State">Campeche</option>
              <option value="QR" class="State-Options MX-State">Quintana Roo</option>
              <option value="YU" class="State-Options MX-State">Yucatán</option>
              <option value="PU" class="State-Options MX-State">Puebla</option>
              <option value="GT" class="State-Options MX-State">Guanajuato</option>
              <option value="NA" class="State-Options MX-State">Nayarit</option>
              <option value="TA" class="State-Options MX-State">Tabasco</option>
              <option value="EM" class="State-Options MX-State">Estado de México</option>
              <option value="HI" class="State-Options MX-State">Hidalgo</option>
              <option value="QE" class="State-Options MX-State">Querétaro</option>
              <option value="CL" class="State-Options MX-State">Colima</option>
              <option value="AG" class="State-Options MX-State">Aguascalientes</option>
              <option value="MO" class="State-Options MX-State">Morelos</option>
              <option value="TL" class="State-Options MX-State">Tlaxcala</option>
              <option value="MX" class="State-Options MX-State">Ciudad de México</option>
  
              <option value="AB" class="State-Options CA-State">Alberta</option>
              <option value="BC" class="State-Options CA-State">British Columbia</option>
              <option value="MB" class="State-Options CA-State">Manitoba</option>
              <option value="NB" class="State-Options CA-State">New Brunswick</option>
              <option value="NL" class="State-Options CA-State">Newfoundland and Labrador</option>
              <option value="NS" class="State-Options CA-State">Nova Scotia</option>
              <option value="ON" class="State-Options CA-State">Ontario</option>
              <option value="PE" class="State-Options CA-State">Prince Edward Island</option>
              <option value="QC" class="State-Options CA-State">Quebec</option>
              <option value="SK" class="State-Options CA-State">Saskatchewan</option>
              <option value="NT" class="State-Options CA-State">Northwest Territories</option>
              <option value="YT" class="State-Options CA-State">Yukon</option>
              <option value="NU" class="State-Options CA-State">Nunavut</option>
  
              <option value="CM" class="State-Options TH-State">Chiang Mai</option>
              <option value="PT" class="State-Options TH-State">Phetchaburi</option>
              <option value="CR" class="State-Options TH-State">Chiang Rai</option>
              <option value="TK" class="State-Options TH-State">Tak</option>
              <option value="PK" class="State-Options TH-State">Prachuap Khiri Khan</option>
              <option value="KB" class="State-Options TH-State">Krabi</option>
              <option value="LN" class="State-Options TH-State">Lamphun</option>
              <option value="KP" class="State-Options TH-State">Kamphaeng Phet</option>
              <option value="PG" class="State-Options TH-State">Phangnga</option>
              <option value="PL" class="State-Options TH-State">Phitsanulok</option>
              <option value="ST" class="State-Options TH-State">Nakhon Si Thammarat</option>
              <option value="UT" class="State-Options TH-State">Uthai Thani</option>
              <option value="NN" class="State-Options TH-State">Nan</option>
              <option value="KK" class="State-Options TH-State">Kanchanaburi</option>
              <option value="SR" class="State-Options TH-State">Surat Thani</option>
              <option value="SN" class="State-Options TH-State">Satun</option>
              <option value="NK" class="State-Options TH-State">Nakhon Ratchasima</option>
              <option value="SH" class="State-Options TH-State">Songkhla</option>
              <option value="PB" class="State-Options TH-State">Phetchabun</option>
              <option value="NY" class="State-Options TH-State">Nakhon Nayok</option>
              <option value="SI" class="State-Options TH-State">Sukhothai</option>
              <option value="LE" class="State-Options TH-State">Loei</option>
              <option value="HH" class="State-Options TH-State">Mae Hong Son</option>
              <option value="CB" class="State-Options TH-State">Chon Buri</option>
              <option value="CM" class="State-Options TH-State">Chaiyaphum</option>
              <option value="CP" class="State-Options TH-State">Chumphon</option>
              <option value="NS" class="State-Options TH-State">Nakhon Sawan</option>
              <option value="RT" class="State-Options TH-State">Ratchaburi</option>
              <option value="TG" class="State-Options TH-State">Trang</option>
              <option value="LP" class="State-Options TH-State">Lampang</option>
              <option value="NT" class="State-Options TH-State">Narathiwat</option>
              <option value="CC" class="State-Options TH-State">Chachoengsao</option>
              <option value="RY" class="State-Options TH-State">Rayong</option>
              <option value="YL" class="State-Options TH-State">Yala</option>
              <option value="UD" class="State-Options TH-State">Uttaradit</option>
              <option value="PL" class="State-Options TH-State">Phatthalung</option>
              <option value="KK" class="State-Options TH-State">Khon Kaen</option>
              <option value="CE" class="State-Options TH-State">Chanthaburi</option>
              <option value="BK" class="State-Options TH-State">Krung Thep Maha Nakhon [Bangkok]</option>
              <option value="RG" class="State-Options TH-State">Ranong</option>
              <option value="SP" class="State-Options TH-State">Samut Prakan</option>
              <option value="PB" class="State-Options TH-State">Prachin Buri</option>
              <option value="PU" class="State-Options TH-State">Phuket</option>
              <option value="TT" class="State-Options TH-State">Trat</option>
              <option value="BR" class="State-Options TH-State">Buri Ram</option>
              <option value="PY" class="State-Options TH-State">Phayao</option>
              <option value="SB" class="State-Options TH-State">Saraburi</option>
              <option value="NP" class="State-Options TH-State">Nakhon Pathom</option>
              <option value="PC" class="State-Options TH-State">Phichit</option>
              <option value="UD" class="State-Options TH-State">Udon Thani</option>
              <option value="SS" class="State-Options TH-State">Samut Sakhon</option>
              <option value="PN" class="State-Options TH-State">Pattani</option>
              <option value="LB" class="State-Options TH-State">Lop Buri</option>
              <option value="PT" class="State-Options TH-State">Pathum Thani</option>
              <option value="SK" class="State-Options TH-State">Sa Kaeo</option>
              <option value="UB" class="State-Options TH-State">Ubon Ratchathani</option>
              <option value="SP" class="State-Options TH-State">Suphan Buri</option>
              <option value="SM" class="State-Options TH-State">Samut Songkhram</option>
              <option value="AY" class="State-Options TH-State">Phra Nakhon Si Ayutthaya</option>
              <option value="NK" class="State-Options TH-State">Nong Khai</option>
              <option value="PR" class="State-Options TH-State">Phrae</option>
              <option value="MS" class="State-Options TH-State">Maha Sarakham</option>
              <option value="SI" class="State-Options TH-State">Si Sa Ket</option>
              <option value="SN" class="State-Options TH-State">Surin</option>
              <option value="BK" class="State-Options TH-State">Bueng Kan</option>
              <option value="NB" class="State-Options TH-State">Nonthaburi</option>
              <option value="YS" class="State-Options TH-State">Yasothon</option>
              <option value="RE" class="State-Options TH-State">Roi Et</option>
              <option value="NP" class="State-Options TH-State">Nakhon Phanom</option>
              <option value="MD" class="State-Options TH-State">Mukdahan</option>
              <option value="SN" class="State-Options TH-State">Sakon Nakhon</option>
              <option value="AC" class="State-Options TH-State">Amnat Charoen</option>
              <option value="KS" class="State-Options TH-State">Kalasin</option>
              <option value="CN" class="State-Options TH-State">Chai Nat</option>
              <option value="NB" class="State-Options TH-State">Nong Bua Lam Phu</option>
              <option value="AT" class="State-Options TH-State">Ang Thong</option>
              <option value="SB" class="State-Options TH-State">Sing Buri</option>
  
  
            </select>
            <span class="error errorStateProvinceRegion">State/Province is required</span>
            <span class="error invalidStateProvinceRegion">State/Province is invalid</span>
          </div>
          <div class="col dis_1">
  
            <input type="text" class="form-control" aria-label="Zip Code/Postal Code *"
              placeholder="Zip Code/Postal Code *" name="Zipcode" required>
            <span class="error errorZipcode">Zip Code is required</span>
            <span class="error invalidZipcode">Zip Code is invalid</span>
          </div>
        </div>
        <div class="row sp-fm0">
          <div class="col dis_1">
            <input type="email" class="form-control" aria-label="Email *" placeholder="Email *" name="Email" required>
            <span class="error errorEmail">Email is required</span>
            <span class="error invalidEmail">Email is invalid</span>
          </div>
          <div class="col dis_1">
  
            <input type="text" class="form-control" aria-label="Phone *" placeholder="Phone *" name="PhoneNumber"
              required>
            <span class="error errorPhoneNumber">Phone number is required</span>
            <span class="error invalidPhoneNumber">Phone number is invalid</span>
          </div>
        </div>
        <div class="row row-new sp-fm0">
          <div class="col-md-6 dis_1 ">
            <select id="inputState" aria-label="How Can We Help" class="form-select ds" name="HowCanWeHelp" required>
              <option value="" disabled selected>How can we help? *</option>
              <option value="4">I have a service inquiry</option>
              <option value="1">I'm interested in your services</option>
            </select>
            <span class="error errorHowCanWeHelp">How can we help is required</span>
            <span class="error invalidHowCanWeHelp">How can we help is invalid</span>
          </div>
          <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">
  
  
            <div class="g-recaptcha" data-callback="recaptchaCallback"
              data-sitekey="6LeWTwUcAAAAAP0S-FWFcCQqwCB7Bc1tj6uOegT_"></div>
            <span class="error errorCaptchaVal">Recaptcha is required</span>
            <span class="error invalidCaptchaVal">Recaptcha is invalid</span>
  
          </div>
          <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
            <div class="hero-panel-button sli-btn form-submit">
              <button class="get-secret-btn form-sub submit-form" tabindex="-1">Submit
              </button>
            </div>
          </div>
  
  
        </div>
  
      </form>
    </div>
  
  
    <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
      <h2 class="comm-head">
        Support When You Need It</h2>
      <p class="text-center">Understand UPS Capital solutions, claims guides, and contact information.</p>
      <p></p>
  
    </div>
  
  
    <div class="row  shp-bgo cont-bg0">
      <div class="col-md-4 max-1200  ic-01 ">
        <div class="text-center  img-tag">
          <img class="rounded d-block ico-img" alt="contact-us" src="../../../assets/redesignImages/privacy_tip.png" />
        </div>
  
        <div class="wrapper wrap-bus">
  
          <p class="tit-0 maj">Find Out What Services We Offer</p>
          
          <div class="hero-panel-button tit-0 ">
            <a class="get-secret-btn btn-wrap button-1" tabindex="-1" href="">View Solutions
              <img class="blue-tags" alt="contact-us" src="../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
  
      </div>
      <div class="col-md-4 ic-02">
        <div class="text-center img-tag">
          <img class="ico-img rounded d-block" alt="contact-us" src="../../../assets/redesignImages/computer.png" />
        </div>
        <div class="wrapper wrap-bus">
          <p class="tit-0 maj ">File a UPS Capital Claim
          </p>
          <div class="hero-panel-button tit-0 ">
            <a class=" btn-wrap get-secret-btn button-2" tabindex="-1" href="https://online.upscapital.com/login"
              target="_blank" rel="noopener">View Claims Guide
              <img class="blue-tags" alt="contact-us" src="../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
      </div>
      <div class="col-md-4 ic-02 ">
        <div class="text-center img-tag">
          <img class="ico-img rounded d-block" alt="contact-us" src="../../../assets/redesignImages/support_agent.png" />
        </div>
        <div class="wrapper wrap-bus tit-0">
          <p class="tit-0 maj">Get In Touch
            With Us</p>
          <div class="hero-panel-button tit-0">
            <a class="btn-wrap get-secret-btn button-3" tabindex="-1" target="_blank"
              href="https://www.insureshield.com/us/en/shipping-insurance/select-my-coverage.html" rel="noopener">Customer
              Support <img class="blue-tags" alt="contact-us" src="../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
      <h2 class="comm-head">
        Frequently Asked Questions</h2>
      <p></p>
  
    </div>
  
    <div class="accordion" id="accordionExample">
      <p class="accordion-subheading">Claims</p>
      <div class="accordion-item ">
        <h2 class="accordion-header media-margin" id="headingOne">
          <button class="margin-acc-value accordion-button-media accordion-button collapsed accordion-colour"
            type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false"
            aria-controls="collapseOne">
            What documents are needed to support my claim?
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse " aria-labelledby="headingOne"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            InsureShield shipping insurance is protection for your in-transit goods offered through
            UPS Capital Insurance Agency, Inc.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header media-margin" id="headingTwo">
          <button class="margin-acc-value accordion-button collapsed accordion-colour" type="button"
            data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            When should I report a claim?
          </button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            Coverage for loss, damage and porch piracy is included. You may also benefit from other
            items including concealed damage up to 90 days, expedited reshipment for replacement
            goods and more.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header media-margin" id="headingThree">
          <button class="margin-acc-value accordion-button collapsed accordion-colour" type="button"
            data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            How can I check the status of my claim?
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            Each policy and application of protection is different. A great place to start is
            reviewing your policy. You can access your policy 24/7 through the <a class="acc-classs"
              href="https://online.upscapital.com/login" target="_blank" rel="noopener"> online
              portal </a>or
            reach out to a member of our team to walk you through your policy one-on-one. </div>
        </div>
      </div>
      <p class="accordion-subheading">Products</p>
      <div class="accordion-item ">
        <h2 class="accordion-header" id="headingFour">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            What is covered under business services?
          </button>
        </h2>
        <div id="collapseFour" class="accordion-collapse collapse " aria-labelledby="headingFour"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            For any modifications to coverage, or to update your contact information or address, you
            can email <a class="acc-classs" href="mailto:capitalus@ups.com">capitalus@ups.com</a> or call <a
              class="acc-classs" href="tel:877-263-8772">877-263-8772</a> to speak to a
            representative. </div>
        </div>
      </div>
  
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingSix">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
            What are Payment Services?
          </button>
        </h2>
        <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            <p>You can pay your UPS Capital<sup class="sup-m">®</sup> invoice through the online
              portal or mail the payment
              to the address on your invoice.</p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingSeven">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree">
            What is Enhanced Carrier Protection?
          </button>
        </h2>
        <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            which your account is located.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingEight">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseThree">
            What is Cargo Insurance?
          </button>
        </h2>
        <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            which your account is located.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingNine">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseThree">
            What is Freight Forwarding Liability Insurance?
          </button>
        </h2>
        <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            which your account is located.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingTen">
          <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseThree">
            What is Parcel Pro Select?
          </button>
        </h2>
        <div id="collapseTen" class="accordion-collapse collapse" aria-labelledby="headingTen"
          data-bs-parent="#accordionExample">
          <div class="accordion-body body-with-no-padding">
            which your account is located.
          </div>
        </div>
      </div>
    </div>
    <p></p>
    <p></p>
    <p></p>
  </div>
  